import { Button } from '@/components/Button';
import { MdAdd } from 'react-icons/md';

type Props = {
  CandidatesJobPostEndpointsOpen: () => void;
};

export default function CandidatesOfferListNotFound({ CandidatesJobPostEndpointsOpen }: Props) {
  return (
    <div className="flex w-full flex-col items-center justify-center">
      <img
        src="/agent/candidates/offer-no-data.svg"
        className="mt-[34px]"
        width={148}
        height={144}
      />
      <Button size={'lg'} className="mt-[52px]" onClick={CandidatesJobPostEndpointsOpen}>
        <MdAdd className="size-icon-sm" />
        提案求人を追加しましょう
      </Button>
    </div>
  );
}
